import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import { Modal, Alert } from 'react-bootstrap';

export default class CustomerProjects extends React.Component {
    state = {
        fromDate: new Date(moment().subtract(1, 'months')),
        toDate: new Date(moment()),
        selectedProjects: [],
        showModal: false,
        showWarning: false
    }

    setFromDate = (date) => {
        this.setState({ fromDate: date })
    }

    setToDate = (date) => {
        this.setState({ toDate: date })
    }

    toggleProject = (selectedProjectId) => {
        if (this.state.selectedProjects.includes(selectedProjectId)) {
            const newSelectedProjects = this.state.selectedProjects.filter(projectId => projectId !== selectedProjectId)
            this.setState({ selectedProjects: newSelectedProjects })
        } else {
            const selectedProjects = [ ...this.state.selectedProjects, selectedProjectId ]
            this.setState({ selectedProjects })
        }
    }

    toggleSelectAllProjects = () => {
        if (this.areAllProjectsSelected()) {
             // Remove all projects
            this.setState({ selectedProjects: [] })
        } else {
            // Add all projects
            const allProjects = this.props.projects.map(project => project._id)
            this.setState({ selectedProjects: allProjects })
        }
    }

     

    areAllProjectsSelected = () => {
        const { projects } = this.props
        const { selectedProjects } = this.state
        const filteredProjects = projects.filter(project => !selectedProjects.includes(project._id))

        return filteredProjects.length === 0
    }

    showModal = () => {
        this.setState({ showModal: true })
    }

    hideModal = () => {
        this.setState({ showModal: false })
        this.resetForm()
    }

    showWarning = () => {
        this.setState({ showWarning: true })
    }

    hideWarning = () => {
        this.setState({ showWarning: false })
    }

    resetForm = () => {
        this.setState({
            fromDate: new Date(moment().subtract(1, 'months')),
            toDate: new Date(moment()),
            selectedProjects: [],
        })
    }

    handleGenerateReportOnClick = async (fromDate, toDate, selectedProjects) => {
        if (!selectedProjects.length) {
            return this.showWarning()
        }

        try {
            await this.props.generateCsvReport(fromDate, toDate, selectedProjects)
            this.showModal()
        } catch (error) {
            console.error('Error generating reports', error)
            alert('Something went wrong generating the report. Please communicate it to our Engineering Team')
        }
    }

    render() {
        const { fromDate, toDate, selectedProjects, showWarning } = this.state
        const { projects } = this.props

        return (
            <div className="customer-reports">
                <label className="box-label">Generate CSV report</label>

                { showWarning && <Alert bsStyle="warning" onDismiss={this.hideWarning}>Please select at least one project</Alert> }

                <div className="dates-container">
                    <h4>Select date range</h4>
                    <div>
                        <span>From</span>
                        <DatePicker className="form-control" selected={fromDate} onChange={this.setFromDate}/>
                    </div>
                    <div>
                        <span>To</span>
                        <DatePicker className="form-control" selected={toDate} onChange={this.setToDate}/>
                    </div>
                </div>
                
                <div className="select-projects">
                    <div className="project-item" onClick={this.toggleSelectAllProjects}>
                    <input 
                        type="checkbox"
                        checked={this.areAllProjectsSelected()} 
                        onChange={this.toggleSelectAllProjects}
                    />
                    <p>Select All Projects</p>
                    </div>
                    <div className="projects-list">
                        { projects && projects.map(project => {
                            return (
                                <div key={project._id} className="project-item" onClick={() => this.toggleProject(project._id)}>
                                    <input 
                                        type="checkbox"
                                        checked={selectedProjects.includes(project._id)} 
                                        onChange={() => this.toggleProject(project._id)} 
                                    />
                                    <p>{project.name}</p>
                                </div>
                            ) 
                        }) }
                    </div>
                </div>
        
                <div>
                    <button 
                        className="btn btn-primary generate-report-button" 
                        onClick={() => this.handleGenerateReportOnClick(fromDate, toDate, selectedProjects)}>
                            Generate Report
                    </button>
                </div>
            
                <Modal show={this.state.showModal} onHide={this.hideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Report is being generated</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div><p>Your Report is being generated. Once it's ready, we’ll send it to you as an email.</p></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={this.hideModal}>Got it</button>
                    </Modal.Footer>
                </Modal>
            </div>
        ); // return
    } // render
}; // CustomerProjects